import request from '@/utils/request'

export function getItcs(params) {
    return request({
        url: '/index/country',
        method: 'get',
        params
    })
}


export function kefu(params) {
    return request({
        url: '/index/kefu',
        method: 'get',
        params
    })
}

export function gundong(params) {
    return request({
        url: '/index/gundong',
        method: 'get',
        params
    })
}

export function index(params) {
    return request({
        url: '/index/index',
        method: 'get',
        params
    })
}

